var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "float_card" }, [
    _c("div", { staticClass: "card_title" }, [
      _c("span", [_vm._v(_vm._s(_vm.getLangMsg("intvTaskCale_intv_data")))]),
      _c("span", { staticClass: "card_close", on: { click: _vm.closePop } })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card_body" }, [
      _c(
        "div",
        { staticClass: "card_body_box" },
        _vm._l(_vm.taskList, function(itemTaskDef, indexTaskDef) {
          return _c(
            "div",
            {
              staticClass: "card_body_item",
              class: {
                card_body_item_new:
                  new Date(itemTaskDef.endTimeLong) > new Date()
              }
            },
            [
              _c("div", { staticClass: "left_icon" }, [
                new Date(itemTaskDef.endTimeLong) < new Date()
                  ? _c("div", { staticClass: "kdfont kdfont-jianchatongguo" })
                  : _c("div", {
                      staticClass: "kdfont kdfont-jinxingzhong",
                      staticStyle: { color: "#FF991C" }
                    }),
                _vm._v(" "),
                indexTaskDef !== _vm.taskList.length - 1
                  ? _c("div", { staticClass: "guide_line" })
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "right_box",
                  on: {
                    click: function($event) {
                      return _vm.toTaskDetail(itemTaskDef.taskId)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "title_state" }, [
                    _c(
                      "div",
                      {
                        staticClass: "title",
                        attrs: { title: itemTaskDef.intvTitle }
                      },
                      [_vm._v(_vm._s(itemTaskDef.intvTitle))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "intv_time" }, [
                    _c("div", { staticClass: "colorGray" }, [
                      _vm._v(_vm._s(_vm.getLangMsg("intvTaskCale_intv_time")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "colorBlack" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm._f("formatHM")(itemTaskDef.startTimeLong)
                          ) +
                          "-" +
                          _vm._s(_vm._f("formatHM")(itemTaskDef.endTimeLong)) +
                          "\n            "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: itemTaskDef.interviewMethodId === 1010,
                          expression: "itemTaskDef.interviewMethodId===1010"
                        }
                      ],
                      staticClass: "intv_spot"
                    },
                    [
                      _c("div", { staticClass: "colorGray" }, [
                        _vm._v(
                          _vm._s(_vm.getLangMsg("intvTaskCale_intv_place"))
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "colorBlack",
                          attrs: { title: itemTaskDef.intvAddress }
                        },
                        [_vm._v(_vm._s(itemTaskDef.intvAddress))]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            itemTaskDef.interviewMethodId === 1010 &&
                            itemTaskDef.intvRoom !== "",
                          expression:
                            "itemTaskDef.interviewMethodId===1010 && itemTaskDef.intvRoom !== ''"
                        }
                      ],
                      staticClass: "intv_room"
                    },
                    [
                      _c("div", { staticClass: "colorGray" }, [
                        _vm._v(_vm._s(_vm.getLangMsg("intvTaskCale_intv_room")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "colorBlack",
                          attrs: { title: itemTaskDef.intvRoom }
                        },
                        [_vm._v(_vm._s(itemTaskDef.intvRoom))]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: itemTaskDef.interviewMethodId === 1040,
                          expression: "itemTaskDef.interviewMethodId===1040"
                        }
                      ],
                      staticClass: "intv_videourl"
                    },
                    [
                      _c("div", { staticClass: "colorGray" }, [
                        _vm._v(
                          _vm._s(_vm.getLangMsg("intvTaskCale_intv_place"))
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "colorBlack",
                          attrs: {
                            href: itemTaskDef.intvAddress,
                            target: "_blank"
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.getLangMsg("intvTaskCale_intv_videoLink")
                            )
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "intv_candidate" }, [
                    _c("div", { staticClass: "colorGray" }, [
                      _vm._v(
                        _vm._s(_vm.getLangMsg("intvTaskCale_intv_candidate"))
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "colorBlack",
                        attrs: {
                          title:
                            itemTaskDef.candidates &&
                            itemTaskDef.candidates.length > 0
                              ? itemTaskDef.candidates.join(",")
                              : ""
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.formatCandidates(itemTaskDef.candidates)
                            ) +
                            "\n            "
                        )
                      ]
                    )
                  ])
                ]
              )
            ]
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }